/**
 * Copyright 2025 AutoZone, Inc.
 * Content is confidential to and proprietary information of AutoZone, Inc., its
 * subsidiaries and affiliates.
 */
import root from 'window-or-global';
import { clickTrack } from '@/utils/analytics/clickTrack';

export const trackRatingOnlyReview = (rating: number, productIdList: string[]) => {
  const { pageName, pageType = '', siteSection } = root.utag_data ?? {};
  clickTrack({
    customLinkName: `productRatingSelection-${pageType}`,
    eventType: 'ratingSelected',
    pageName,
    pageType,
    siteSection,
    productIdList: productIdList,
    ratingClicked: rating,
  });
};
